export const StorageItemFileTypes = {
  VIDEO: "video",
  JPEG: "image/jpeg"
};
